module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_08-135aa9192d940e7361e3aaf3f81cb3ea.webp";